import React from 'react';
import { Breadcrumb } from '../presentation/Breadcrumb';
import { CategoryBanner } from '../presentation/CategoryBanner';
import { SidebarWidget } from '../presentation/SidebarWidget';
import { Category } from '../presentation/Category';
import { Header } from "../presentation/Header";
import { Footer } from '../presentation/Footer';

export const Store = () => {
  return (
    <>
      <Header />
      <CategoryBanner />
      <Breadcrumb />
      <div className="lg:px-16 px-7 flex flex-col lg:flex-row">
        <SidebarWidget />
        <Category />
      </div>
      <Footer />
    </>
  )
}